import R from "ramda";
import { useSelector } from "react-redux";

import { usePeopleActions } from "store/PeopleSlice";

const usePeople = () => {
  const {
    loadPeople,
    loadAdditionalPeople,
    createPerson,
    deletePerson,
    addHeadToPerson,
    resetPeople,
    updatePerson,
    addPersonToUpdate,
    resetPeopleToUpdate,
  } = usePeopleActions();

  const { people, meta, peopleToUpdate } = useSelector((state) => state.PeopleSlice);

  const personAttributes = (personParams, head) => ({
    data: {
      type: "people",
      attributes: personParams,
      relationships: {
        heads: {
          data: [
            {
              type: "heads",
              id: head.id,
            },
          ],
        },
      },
    },
  });

  const personUpdateAttributes = (person) => {
    const { name, relation, birthday, anniversary, defaultHead, newDefaultHeadId } = person;
    return {
      data: {
        id: person.id,
        type: "people",
        attributes: {
          name,
          relation,
          birthday,
          anniversary,
          defaultHeadId: newDefaultHeadId,
        },
        relationships: {
          defaultHead: {
            data: {
              id: defaultHead ? defaultHead.id : newDefaultHeadId,
              type: "default-heads",
            },
          },
        },
      },
    };
  };

  return {
    loadPeople,
    meta,
    loadAdditionalPeople,
    resetPeople,
    deletePerson: (personId) => {
      const params = { deleteHeads: true };
      return deletePerson(personId, params);
    },
    createPerson: (personParams, head) => {
      const attributes = personAttributes(personParams, head);
      return createPerson(attributes);
    },
    updatePerson: (person) => {
      const params = personUpdateAttributes(person);
      return updatePerson(person.id, params);
    },
    addHeadToPerson,
    people,
    totalPeopleCount: R.propOr(people.count, "totalCount", meta),
    peopleToUpdate,
    addPersonToUpdate,
    resetPeopleToUpdate,
  };
};

export default usePeople;
